(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mosaic"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const promoBlocks = document.querySelectorAll('.mosaic__item .promo-block');

    promoBlocks.forEach(function(block) {
      block.addEventListener('touchstart', function(e) {
        const isActive = this.classList.contains('gif-active');
        promoBlocks.forEach(function(b) { b.classList.remove('gif-active'); });
        if (!isActive) {
          this.classList.add('gif-active');
          e.preventDefault();
        }
      }, { passive: false });
    });

    document.addEventListener('touchstart', function(e) {
      if (!e.target.closest('.mosaic__item .promo-block')) {
        promoBlocks.forEach(function(b) { b.classList.remove('gif-active'); });
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
